import 'SprykerCatalogBundle/components/molecules/catalog-breadcrumb';
import 'SprykerProductBundle/components/atoms/product-subtitle';
import 'SprykerProductBundle/components/atoms/product-tile-flag';
import 'SprykerProductBundle/components/atoms/select-size-link';
import 'SprykerProductBundle/components/molecules/availability-notification-subscription';
import 'SprykerProductBundle/components/molecules/bike-detail-availability';
import 'SprykerProductBundle/components/molecules/bike-detail-color-picker';
import 'SprykerProductBundle/components/molecules/bike-detail-size-selector';
import 'SprykerProductBundle/components/molecules/detail-leasing-modal';
import 'SprykerProductBundle/components/molecules/detail-price';
import 'SprykerProductBundle/components/molecules/detail-gp30';
import 'SprykerProductBundle/components/molecules/easy-credit-example-iframe';
import 'SprykerProductBundle/components/molecules/list-buybox-benefits';
import 'SprykerProductBundle/components/molecules/product-detail-feature-list';
import 'SprykerProductBundle/components/molecules/product-detail-info-buttons';
import 'SprykerProductBundle/components/molecules/product-detail-slider';
import 'SprykerProductBundle/components/molecules/product-headline-with-order-number';
import 'SprykerProductBundle/components/molecules/store-availability';
import 'SprykerProductBundle/components/organisms/bike-detail-geo-table';
import 'SprykerProductBundle/components/organisms/bike-detail-payments-special';
import 'SprykerProductBundle/components/organisms/bike-detail-stage';
import 'SprykerProductBundle/components/organisms/product-stage';
import 'SprykerProductBundle/components/organisms/product-payments-special';
import '../bike-detail';
import '../detail';

//########## legacy ##########################################################################

// @ts-ignore
import $ from 'jquery';

import * as userrating from 'ShopUiBundle/assets/js/modules/userrating-validation';
import * as userratingfilter from 'ShopUiBundle/assets/js/modules/userrating-filter';
import * as dropdown from 'ShopUiBundle/assets/js/components/dropdown';
import { updateDebounced as updateLazyLoading } from 'ShopUiBundle/assets/js/components/lazyload';

userrating.bindEvents();
userratingfilter.bindEvents();

declare global {
    interface EpoqNSInterface {
        rsForeignWidgetInit: () => void;
    }

    interface Window {
        EpoqNS: EpoqNSInterface | undefined
    }
}

window.addEventListener('bike-detail.refresh', () => {
    $(document).foundation();
    dropdown.bindEventsWithoutFoundation();
    userratingfilter.bindEvents();
    window.EpoqNS?.rsForeignWidgetInit();
    updateLazyLoading();
});
